export default __webpack_public_path__ + "c03f665db27af43971565560adfba594.png";